import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT


//获取列表数据
export const getListData = (params) => {

  return axios.post(root+'/set/parameter/priceandkd', qs.stringify(params))
}

//获取数据
export const getDetail = (params) => {
  return axios.get(root+'/set/parameter/getpriceandkddetail', {params:params})
}


//删除行
export const deleteData = (params) => {
  return axios.post(root+'/set/parameter/removepriceandkd',  qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (JSON.parse(params.paracontent).unitguid||params.unitguid) {//修改
    return axios.post(root+'/set/parameter/updatepriceandkd', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/set/parameter/savepriceandkd', qs.stringify(params))
  }
}
//充值设置
export const saveRecharge = (params) => {
  if (JSON.parse(params.paracontent).unitguid) {//修改
    return axios.post(root+'/set/parameter/updatepriceandkd', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/set/parameter/saveRecharge', qs.stringify(params))
  }
}

//超额包邮
export const save = (params) => {
  if (params.paragroup) {//修改
    return axios.post(root+'/set/parameter/update', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/set/parameter/save', qs.stringify(params))
  }
}



// WEBPACK FOOTER //
// ./src/api/set/PriceandKd.js